import { render } from "./ObserveBase.vue?vue&type=template&id=13993780"
import script from "./ObserveBase.vue?vue&type=script&lang=js"
export * from "./ObserveBase.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./ObserveBase.vue?vue&type=style&index=0&id=13993780&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script